module.exports = __webpack_public_path__ + "img/airport-icon.6ca22da3.png";